import { getIn } from 'seamless-immutable';

export const getBuyTogetherProductId = shelf => getIn(shelf, ['products', '0', 'id'], '');

export const ftmProductImage = product => getIn(product, ['images', '0', 'large'], '');

export const closureBuyTogether = (client, dispatchMetrics, query, active, price, sku, sellerId) => () => {
  if (!active) {
    dispatchMetrics('event:track', {
      action: 'add',
      category: 'product',
      label: 'combo-vip',
    });
  }

  client.writeQuery({
    query,
    data: {
      buyTogetherVIP: { active: !active, price, sku, sellerId },
    },
  });
};
